import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Form, Formik, Field } from "formik";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import RadioButton from "web/components/form-elements/RadioButton";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import { checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import states from "states-us";
import Button from "web/components/Button";
import Spinner from "web/components/Spinner";
import TextInput from "web/components/form-elements/TextInput";

import NumberInput from "web/components/form-elements/NumberInput";
import AlertModal from "web/components/AlertModal";
import { addLocation } from "redux/actions/accountSetting";
import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from "web/components/utils/addLocationUtils";

import styles from "./add-location.module.scss";
import CloseIcon from "web/assets/images/CloseIcon.png";
import styled from "styled-components";
import AddIcon from "web/assets/images/plus-icon.webp";
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";

const AddLocation = ({
  buttonName,
  loadResponse,
  onChange,
  pageLanguageContents,
}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  let history = useHistory();
  let brokerAccount = localStorage.getItem("brokerAccount");

  const [locationType, setlocationType] = useState("independentLocation");
  const [hideShow, setHideShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);
  const [tooltipPurchaseLimit, setTooltipPurchaseLimit] = useState(false);
  const [acknowledgeState, setAcknowledgeState] = useState(false);
  let title = "";

  const [isOpen, toggle] = useState(false);

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = [];

  for (let i = 0; i < territoryStates.length; i++) {
    let obj = {
      value: territoryStates[i].name,
      label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
      isoCode: territoryStates[i].abbreviation,
    };
    stateArr.push(obj);
  }

  const [ignoreAddress, setIgnoreAddress] = useState(false);
  const mixFieldsState = [
    {
      name: pageLanguageContents?.Add_Location[9]?.HybridOptions,
      value: "independent",
      yesNo: [
        {
          name: pageLanguageContents?.Add_Location[10]?.IndependentLocation,
          value: "true",
        },
        {
          name: pageLanguageContents?.Add_Location[11]?.DependentLocation,
          value: "false",
        },
      ],
    },
  ];
  const handleAddLocation = async (props) => {
    const { values, resetForm } = props;
    let purchasingLimit;
    if (
      loadResponse.response.listCorporateLocations &&
      loadResponse.response.listCorporateLocations[0].adminPaymentMode ===
        "INDEPENDENT"
    ) {
      purchasingLimit = props.values.purchasingLimitIndependent.substring(1);
    } else {
      purchasingLimit = props.values.purchasingLimitDependent.substring(1);
    }

    let independent = props.values.independent;

    if (independent === "true") {
      independent = true;
    } else {
      independent = false;
    }

    if (
      loadResponse.response.userDetail.corporateAdminDetails &&
      loadResponse.response.userDetail.corporateAdminDetails.paymentMode ===
        "INDEPENDENT"
    ) {
      independent = true;
    }
    let data = {
      locationName: props.values.addLocation,
      handlePayment: independent,
      ignoreAddressValidation: ignoreAddress,
      address: {
        line1: props.values.line1,
        line2: props.values.line2,
        city: props.values.city,
        zip: props.values.zip,
        state: props.values.state,
      },
      purchasingLimit: purchasingLimit ? parseInt(purchasingLimit) : 0,
    };
    const response = await dispatch(addLocation(data, token));
    if (response.status === "FAILURE") {
      if(response.message === "Missing request header 'authId' for method parameter of type String"){
        history.push('/sign-in');
        window.location.reload(false);
      }else{
        // to display message from content sheet
        let indexVal = null;
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === response.message) {
              indexVal = index;
            }
          });
        }
        if (indexVal !== null) setModalContent(response?.error[0]?.message)
        else setModalContent(response.message);
  
        setModalLink("");
        toggleModal();
      }
    } else {
      if (response.error && response.error[0].code === "ADDRESS_VALIDATION_ERR")
        setIgnoreAddress(true);

      setlocationType("independentLocation");
      resetForm({ values: "" });
      onChange();
      toggle(!isOpen);
      setHideShow(!hideShow);

      // to display message from content sheet
      let indexVal = null;
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.message) {
            indexVal = index;
          }
        });
      }
      if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
      else setModalContent(response.message);

      setModalLink("");
      toggleModal();
    }
  };
  const accountType = (props) => {
    const { validateForm, setTouched } = props;
    return (
      mixFieldsState &&
      mixFieldsState.map((value, index) => (
        <div className="row" key={index}>
          <div className="col-12 p-0">
            <div>
              <div className={`text-left mt-4 mb-2 ${styles.forRadio}`}>
                {mixFieldsState[index].yesNo &&
                  mixFieldsState[index].yesNo.map((yesNoValue, setIndex) => (
                    <div className={`col-md-12 ${styles.field}`} key={setIndex}>
                      <Field
                        component={RadioButton}
                        name={mixFieldsState[index].value}
                        id={yesNoValue.value}
                        defaultValue={mixFieldsState[index].yesNo[0].value}
                        onSelect={(e) => {
                          locationTypeSelect(e);
                          validateForm();
                          setTouched({});
                        }}
                        label={yesNoValue.name}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ))
    );
  };

  const locationTypeSelect = (e) => {
    if (e.target.value === "true") setlocationType("dependentLocation");
    else setlocationType("independentLocation");
  };

  const purchaseLimitIcon = (infoTxt) => {
    return (
      <>
        <img
          id="PasswordIcon"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-2px",
            width: "21px",
            height: "16px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipPurchaseLimit}
          target="PasswordIcon"
          toggle={() => setTooltipPurchaseLimit(!tooltipPurchaseLimit)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };
  const callFunction = async(value,setFieldValue)=>{
    const token = localStorage.getItem('token')     
    let response = '';
    if (value.length === 5) {
        response = await dispatch(checkIsZipCode(value, token))
        if (response.success) {
          setFieldValue('city',response?.data?.city)
          setFieldValue('zip',response?.data?.zipCode)
          setFieldValue('state',response?.data?.state)
           
        } else {
            if (response?.data?.error?.message === 'Invalid Zip Code.') {
               setFieldValue('city',"")
              setFieldValue('zip',"")
              setFieldValue('state',"")
              setModalContent("Invalid Zip Code.")
              toggleModal()  
              setModalLink("");              
            } else if (response.error?.message === "Invalid Token" || response.message === 'Request failed with status code 401') {
                history.push('/sign-in')
                window.location.reload(false);
            } else {

            }
        }
    } else {
      setFieldValue('city',"")
      setFieldValue('state',"")     
    }
  }

  return (
    <div className={styles.addLocationContainer}>
      {loaderVisible && <Spinner />}
      <div className={styles.subAccBtn}>
        {brokerAccount !== "brokerAc" && (
          <Button
            type="app-green-button"
            handleClick={() => {
              toggle(!isOpen);
            }}
          >
            {buttonName === "Add Location" && (
              <img src={AddIcon} alt="add-icon" />
            )}
            {buttonName}
          </Button>
        )}
      </div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={"static"}
        centered={true}
        className={styles.addLocation}
      >
        <div className={styles.header}>
          <Button handleClick={() => toggle(!isOpen)}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>
            {pageLanguageContents?.Add_Location[0]?.AddLocation}
            <p>
              Use this screen to create a sub-account for a location in your
              network.
            </p>
          </h3>
        </div>
        <ModalBody className={styles.body}>
          <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={VALIDATION_SCHEMA(
              pageLanguageContents,
              locationType,
              loadResponse
            )}
            onSubmit={(values) => {}}
          >
            {(props) => {
              const { setFieldValue } = props;                          
              return (
                <>
                  {loaderVisible && <Spinner />}
                  <Form
                    className={hideShow === false ? styles.hide : styles.show}
                  >
                    <LocationGroup>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[1]?.LocationName}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="addLocation"
                          placeholder={pageLanguageContents?.Add_Location[12]?.LocationNamePlaceholder}
                          showErrorMessages={true}
                        />
                      </div>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[2]?.AddressLine1}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="line1"
                          placeholder={pageLanguageContents?.Add_Location[2].AddressLine1}
                          showErrorMessages={true}
                        />
                      </div>

                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[3]?.AddressLine2}
                        </p>

                        <TextInput
                          name="line2"
                          placeholder={pageLanguageContents?.Add_Location[3]?.AddressLine2}
                          showErrorMessages={true}
                        />
                      </div>
                    </LocationGroup>
                    <CityGroup>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[5]?.City}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="city"
                          inputType="city"
                          placeholder={pageLanguageContents?.Add_Location[5]?.City}
                        />
                      </div>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[4]?.State}
                          <span className="star">*</span>
                        </p>
                        <TextInput name="state" disabled={true} />
                      </div>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[6]?.Zip}
                          <span className="star">*</span>
                        </p>
                        <NumberInput
                          name="zip"
                          placeholder={pageLanguageContents?.Add_Location[6]?.Zip}
                          maxLength="5"
                          onChangeHandler={(value)=>{                  
                             callFunction(value,setFieldValue)
                            
                          }}
                        />
                      </div>
                      <div>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location[7]?.PurchasingLimit}
                          {loadResponse.response.listCorporateLocations &&
                            loadResponse.response.listCorporateLocations[0]
                              .adminPaymentMode === "INDEPENDENT" &&
                            loadResponse.response.listCorporateLocations &&
                            loadResponse.response.listCorporateLocations[0]
                              .account === "CORPORATE" &&
                            loadResponse.response.userDetail
                              .corporateAdminDetails.paymentMode !==
                              "INDEPENDENT" &&
                            locationType === "independentLocation" && (
                              <span className="star">*</span>
                            )}
                          {loadResponse.response.listCorporateLocations &&
                            loadResponse.response.listCorporateLocations[0]
                              .adminPaymentMode === "HYBRID_CC" &&
                            loadResponse.response.listCorporateLocations &&
                            loadResponse.response.listCorporateLocations[0]
                              .account === "CORPORATE" &&
                            locationType === "independentLocation" && (
                              <span className="star">*</span>
                            )}
                          {purchaseLimitIcon(pageLanguageContents?.Add_Location[13]?.PurchasingLimitToolTip)}
                        </p>
                        {loadResponse.response.listCorporateLocations &&
                        loadResponse.response.listCorporateLocations[0]
                          .adminPaymentMode === "INDEPENDENT" ? (
                          <NumberInput
                            name="purchasingLimitIndependent"
                            prefix={"$"}
                              placeholder={pageLanguageContents?.Add_Location[7]?.PurchasingLimit}
                          />
                        ) : (
                          <NumberInput
                            name="purchasingLimitDependent"
                            prefix={"$"}
                              placeholder={pageLanguageContents?.Add_Location[7]?.PurchasingLimit}
                          />
                        )}
                      </div>
                    </CityGroup>

                    {accountType(props)}

                    <CheckboxInput
                      name="acknowledgementCheckBox"
                      label={pageLanguageContents?.Add_Location[14]?.AcknowledgementCheckBox}
                      handleSelect={(name, label, e) => {
                        setAcknowledgeState(e);
                      }}
                    />

                    <AddLocationBtn className={styles.fieldGroup}>
                      <div className={styles.field}>
                        <Button
                          type="app-green-button submitBtn"
                          handleClick={() => {
                            handleAddLocation(props);
                          }}
                          disabled={
                            loadResponse.response.listCorporateLocations &&
                            loadResponse.response.listCorporateLocations[0]
                              .adminPaymentMode === "INDEPENDENT"
                              ? props.values.addLocation === "" ||
                                props.values.line1 === "" ||
                                props.values.city === "" ||
                                props.values.state === "" ||
                                props.values.zip === "" ||
                                !acknowledgeState
                              : locationType === "dependentLocation"
                              ? props.values.addLocation === "" ||
                                props.values.line1 === "" ||
                                props.values.city === "" ||
                                props.values.state === "" ||
                                props.values.zip === "" ||
                                !acknowledgeState
                              : props.values.addLocation === "" ||
                                props.values.line1 === "" ||
                                props.values.city === "" ||
                                props.values.state === "" ||
                                props.values.zip === "" ||
                                props.values.purchasingLimitDependent === "" ||
                                !acknowledgeState
                          }
                        >
                          {pageLanguageContents?.Add_Location[8]?.AddLocationButton}
                        </Button>
                      </div>
                    </AddLocationBtn>
                  </Form>
                </>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};
export default AddLocation;

const LocationGroup = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 20px;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-bottom: 15px;
    .app-input-text {
      margin: 0;
    }
  }
`;
const CityGroup = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media (max-width: 540px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-bottom: 15px;
    .app-input-text {
      margin: 0;
    }
  }
`;
const AddLocationBtn = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr;
`;
